import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const checkDocTypeInvoiceAndHolderIdRule: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
	const documentType = control.get('documentType')!.value;
	const policyHolderId = control.get('policyHolderId')!.value;
	const invoiceNumber = control.get('invoiceNumber')!.value;

	return (!policyHolderId ||  !invoiceNumber) && documentType === 'EGD025' ?
		{ checkDocTypeInvoiceAndHolderIdFlag: true } : null;

};
